/**
 * Message-bundle aggregator.
 *
 * Re-exports `fi`, `en`, and the `MessageKeys` union derived from the Finnish
 * bundle (the single source of truth for keys, per `research.md` §6 and
 * tasks.md T013) plus a `bundles` map keyed by `LanguageCode` so
 * `useTranslate` can dispatch to the right locale with one typed lookup.
 *
 * The `MessageKeys` alias is the type-system seam that gives both bundles the
 * same set of keys:
 *
 *   type MessageKeys = keyof typeof fi;            // Finnish = authority
 *   const en: Record<MessageKeys, string> = {...}; // English mirrors keys
 *
 * `MessageKeys` is authored in `./fi.ts` beside the Finnish bundle to keep
 * the "Finnish authors the keys" invariant syntactically obvious; consumers
 * should import it from this aggregator rather than reaching into `fi.ts`
 * directly so the indirection stays reader-friendly.
 */

import type { LanguageCode } from '../LanguagePort.js';
import { en } from './en.js';
import { fi, type MessageKeys } from './fi.js';
import { sv } from './sv.js';

export const bundles: Record<LanguageCode, Record<MessageKeys, string>> = {
  fi,
  en,
  sv,
};

export type { MessageKeys };
export { en, fi, sv };
